var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcImportContacts = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "88px",
    viewBox: "0 0 64 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3.-Import",
    transform: "translate(-863.000000, -309.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(35.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2-Copy-11",
    transform: "translate(700.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-cv",
    transform: "translate(128.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,8 L36,8 C36,10.2 34.2,12 32,12 C29.8,12 28,10.2 28,8 L8,8 C3.6,8 0,11.6 0,16 L0,80 C0,84.4 3.6,88 8,88 L56,88 C60.4,88 64,84.4 64,80 L64,16 C64,11.6 60.4,8 56,8 Z",
    id: "Path",
    fill: "#4F5964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,82 L8,82 C6.8,82 6,81.2 6,80 L6,16 C6,14.8 6.8,14 8,14 L56,14 C57.2,14 58,14.8 58,16 L58,80 C58,81.2 57.2,82 56,82 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,8 C36,10.2 34.2,12 32,12 C29.8,12 28,10.2 28,8 L14,8 L14,16 C14,18.2 15.8,20 18,20 L46,20 C48.2,20 50,18.2 50,16 L50,8 L36,8 Z",
    id: "Path",
    fill: "#979FA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C27.6,0 24,3.6 24,8 C24,12.4 27.6,16 32,16 C36.4,16 40,12.4 40,8 C40,3.6 36.4,0 32,0 Z M32,12 C29.8,12 28,10.2 28,8 C28,5.8 29.8,4 32,4 C34.2,4 36,5.8 36,8 C36,10.2 34.2,12 32,12 Z",
    id: "Shape",
    fill: "#979FA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,35 C28,37.76 25.762,40 23,40 C20.238,40 18,37.76 18,35 C18,32.238 20.238,30 23,30 C25.762,30 28,32.238 28,35",
    id: "Path",
    fill: "#FBA32D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,46.658 C32,46.658 29.508,42 23,42 C16.49,42 14,46.658 14,46.658 L14,50 L32,50 L32,46.658 Z",
    id: "Path",
    fill: "#BEC4CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,34 L50,34 L50,38 L38,38 L38,34 Z M38,44 L50,44 L50,48 L38,48 L38,44 Z M14,58 L50,58 L50,62 L14,62 L14,58 Z M14,68 L50,68 L50,72 L14,72 L14,68 Z",
    id: "Shape",
    fill: "#BEC4CA"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcImportContacts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-import-contacts.df992ea1.svg";
export { ForwardRef as ReactComponent };